import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createCustomerValidationForm } from "../../utils/validationSchema";
import Form from "../../layouts/Form";
import CustomerForm from "./CustomerForm";

const CreateCustomer = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(createCustomerValidationForm),
  });
  const { handleCreate, isLoading } = props;

  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <CustomerForm
        clearErrors={clearErrors}
        errors={errors}
        register={register}
        setValue={setValue}
      />
    </Form>
  );
};

export default CreateCustomer;
